import { render, staticRenderFns } from "./TGCacheTable.vue?vue&type=template&id=667ebbec&lang=pug&"
import script from "./TGCacheTable.vue?vue&type=script&lang=js&"
export * from "./TGCacheTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports